export const environment = 
{ 
  production: false,
  appUri: 'https://dlms-minam.bhp.com/',
  baseUrl: 'https://dlmsapi-minam.bhp.com/',
  azureTenant: '4f6e1565-c2c7-43cb-8a4c-0981d022ce20',
  azureScopes: ['57f17086-1701-4cf2-9894-203a94d1b396/DLMS.Read'],
  azureClientId: '57f17086-1701-4cf2-9894-203a94d1b396',
  disableAzureLogin: false
};